import { LinearProgress, Typography } from '@mui/material';
import { FeedbackWrapper } from 'components/FeedbackWrapper';
import DefaultLayout from 'layouts/defaultLayout';
import { useEffect, useRef, useState } from 'react';

const LOADING_DURATION = 15; // Duration in seconds
const TOTAL_STEPS = 100; // Total progress steps (0-100)

const QuotePending = () => {
  const [progress, setProgress] = useState(0);
  const intervalRef = useRef<number | null>(null); // Track the interval to clear it later

  useEffect(() => {
    const startTime = Date.now();

    function updateLoadingBar() {
      const currentTime = Date.now();
      const elapsedTime = (currentTime - startTime) / 1000; // Elapsed time in seconds

      // Calculate the steady progress based on elapsed time
      const targetProgress = Math.min(
        Math.floor((elapsedTime / LOADING_DURATION) * TOTAL_STEPS),
        TOTAL_STEPS,
      );

      setProgress(targetProgress);

      if (targetProgress >= TOTAL_STEPS) {
        if (intervalRef.current !== null) {
          clearInterval(intervalRef.current);
          intervalRef.current = null; // Reset after clearing
        } // Stop updates when complete
      }
    }

    // Set a steady interval for updates
    intervalRef.current = window.setInterval(updateLoadingBar, 100); // Use `window.setInterval`

    // Cleanup the interval on component unmount
    return () => clearInterval(intervalRef.current ?? undefined);
  }, []);

  return (
    <DefaultLayout renderStepper={false} verticalCentered extendContainer>
      <FeedbackWrapper feedback="none" renderHomeButton={false}>
        <Typography variant="h1">
          Your quote is being generated.
          <LinearProgress
            value={progress}
            color="secondary"
            variant="determinate"
            sx={{
              height: 10,
              borderRadius: 5,
              marginY: 2,
            }}
          />
          Please wait a few more seconds while we set everything up!
        </Typography>
      </FeedbackWrapper>
    </DefaultLayout>
  );
};

export default QuotePending;
